import { render } from "./CouponDemo.vue?vue&type=template&id=c05621c0&scoped=true"
import script from "./CouponDemo.vue?vue&type=script&lang=js"
export * from "./CouponDemo.vue?vue&type=script&lang=js"

import "./CouponDemo.vue?vue&type=style&index=0&id=c05621c0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c05621c0"]])

export default __exports__